import {
      GET_TOP_SEARCHED_LIST_FAILURE, GET_TOP_SEARCHED_LIST_REQUEST,
      GET_TOP_SEARCHED_LIST_SUCCESS, USER_DETAILS_FETCHED,
      PROVIDER_SEARCH_REQUEST, PROVIDER_SEARCH_SUCCESS, PROVIDER_SEARCH_FAILURE,
      GET_TAX_ID_SEARCH_LIST_REQUEST,
      GET_TAX_ID_SEARCH_LIST_SUCCESS,
      GET_TAX_ID_SEARCH_LIST_FAILURE,
      GET_GEO_SEGMENTATION_SEARCH_LIST_REQUEST,
      GET_GEO_SEGMENTATION_SEARCH_LIST_SUCCESS,
      GET_GEO_SEGMENTATION_SEARCH_LIST_FAILURE,
      SAVE_SEARCH_DETAILS_REQUEST,
      SAVE_SEARCH_DETAILS_SUCCESS,
      SAVE_SEARCH_DETAILS_FAILURE,
      SAVE_CONTRACT_SEARCH_DETAILS_REQUEST,
      SAVE_CONTRACT_SEARCH_DETAILS_SUCCESS,
      SAVE_CONTRACT_SEARCH_DETAILS_FAILURE,
      SAVE_TINS_GROUP_FAILURE,
      SAVE_TINS_GROUP_SUCCESS,
      SAVE_TINS_GROUP_REQUEST,
      SAVE_GEO_SEARCH_DETAILS_FAILURE,
      SAVE_GEO_SEARCH_DETAILS_SUCCESS,
      SAVE_GEO_SEARCH_DETAILS_REQUEST,
      UPDATE_NAVIGATION_LINK,
      PROVIDER_SEARCH_LOADING
} from '../actionTypes';


export const fetchTopSearchedListRequest = (payload: any) => ({
      type: GET_TOP_SEARCHED_LIST_REQUEST,
      payload
});

export const fetchTopSearchedListSuccess = (payload: any) => ({
      type: GET_TOP_SEARCHED_LIST_SUCCESS,
      payload
});

export const fetchTopSearchedListError = (payload: any) => ({
      type: GET_TOP_SEARCHED_LIST_FAILURE,
      payload
});

export const userDetailsFetched = (payload: any) => ({
      type: USER_DETAILS_FETCHED,
      payload
});


export const providerSearchLoading = (payload: any) => ({
      type: PROVIDER_SEARCH_LOADING,
      payload
});

export const providerSearchRequest = (payload: any) => ({
      type: PROVIDER_SEARCH_REQUEST,
      payload
});
export const providerSearchSuccess = (payload: any) => ({
      type: PROVIDER_SEARCH_SUCCESS,
      payload
});
export const providerSearchFailure = (payload: any) => ({
      type: PROVIDER_SEARCH_FAILURE,
      payload
});



export const fetchTaxIdSearchListRequest = (payload: any) => ({
      type: GET_TAX_ID_SEARCH_LIST_REQUEST,
      payload
});

export const fetchTaxIdSearchListSuccess = (payload: any) => ({
      type: GET_TAX_ID_SEARCH_LIST_SUCCESS,
      payload
});

export const fetchTaxIdSearchListFailure = (payload: any) => ({
      type: GET_TAX_ID_SEARCH_LIST_FAILURE,
      payload
});


export const fetchGeoSegmentationSearchListRequest = (payload: any) => ({
      type: GET_GEO_SEGMENTATION_SEARCH_LIST_REQUEST,
      payload
});

export const fetchGeoSegmentationSearchListSuccess = (payload: any) => ({
      type: GET_GEO_SEGMENTATION_SEARCH_LIST_SUCCESS,
      payload
});

export const fetchGeoSegmentationSearchListFailure = (payload: any) => ({
      type: GET_GEO_SEGMENTATION_SEARCH_LIST_FAILURE,
      payload
});


export const saveSearchDetailsRequest = (payload: any) => ({
      type: SAVE_SEARCH_DETAILS_REQUEST,
      payload
});
export const saveSearchDetailsSuccess = (payload: any) => ({
      type: SAVE_SEARCH_DETAILS_SUCCESS,
      payload
});
export const saveSearchDetailsFailure = (payload: any) => ({
      type: SAVE_SEARCH_DETAILS_FAILURE,
      payload
});

export const saveContractSearchDetailsRequest = (payload: any) => ({
      type: SAVE_CONTRACT_SEARCH_DETAILS_REQUEST,
      payload
});
export const saveContractSearchDetailsSuccess = (payload: any) => ({
      type: SAVE_CONTRACT_SEARCH_DETAILS_SUCCESS,
      payload
});
export const saveContractSearchDetailsFailure = (payload: any) => ({
      type: SAVE_CONTRACT_SEARCH_DETAILS_FAILURE,
      payload
});


export const saveTinsGroupRequest = (payload: any) => ({
      type: SAVE_TINS_GROUP_REQUEST,
      payload
});
export const saveTinsGroupSuccess = (payload: any) => ({
      type: SAVE_TINS_GROUP_SUCCESS,
      payload
});
export const saveTinsGroupFailure = (payload: any) => ({
      type: SAVE_TINS_GROUP_FAILURE,
      payload
});


export const saveGeoSearchDetailsRequest = (payload: any) => ({
      type: SAVE_GEO_SEARCH_DETAILS_REQUEST,
      payload
});
export const saveGeoSearchDetailsSuccess = (payload: any) => ({
      type: SAVE_GEO_SEARCH_DETAILS_SUCCESS,
      payload
});
export const saveGeoSearchDetailsFailure = (payload: any) => ({
      type: SAVE_GEO_SEARCH_DETAILS_FAILURE,
      payload
});

export const updateNavigationLink = (payload: any) => ({
      type: UPDATE_NAVIGATION_LINK,
      payload
});